import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpaceKey = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "space-key",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M14.4444 9.37654C14.4444 9.43384 14.4171 9.4888 14.3685 9.52931C14.3199 9.56983 14.2539 9.59259 14.1852 9.59259H3.81481C3.74605 9.59259 3.68011 9.56983 3.63149 9.52931C3.58287 9.4888 3.55556 9.43384 3.55556 9.37654V7H2V9.37654C2 9.57515 2.04694 9.77181 2.13814 9.95529C2.22935 10.1388 2.36303 10.3055 2.53155 10.4459C2.70007 10.5864 2.90013 10.6978 3.12032 10.7738C3.3405 10.8498 3.57649 10.8889 3.81481 10.8889H14.1852C14.4235 10.8889 14.6595 10.8498 14.8797 10.7738C15.0999 10.6978 15.2999 10.5864 15.4685 10.4459C15.637 10.3055 15.7707 10.1388 15.8619 9.95529C15.9531 9.77181 16 9.57515 16 9.37654V7H14.4444V9.37654Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgSpaceKey);
export { ForwardRef as ReactComponent };
